import { render, staticRenderFns } from "./AccountComments.vue?vue&type=template&id=278a560a&scoped=true&"
import script from "./AccountComments.vue?vue&type=script&lang=js&"
export * from "./AccountComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a560a",
  null
  
)

export default component.exports